import { createContext, memo, useContext, useMemo } from 'react';
import { noop } from '@cbhq/cds-utils/noop';

import useLocalStorage, { SetValue } from ':cloud/hooks/useLocalStorage';
import { ProjectWithRole } from ':cloud/types/service_proto';

type ProjectContextType = {
  selectedProject: ProjectWithRole | null;
  setSelectedProject: SetValue<ProjectWithRole | null>;
};

const ProjectContext = createContext<ProjectContextType>({
  selectedProject: null,
  setSelectedProject: noop,
});

export const ProjectProvider = memo(function ProjectProvider({ children }) {
  const [selectedProject, setSelectedProject] = useLocalStorage<ProjectWithRole | null>(
    'selected-project',
    null,
  );

  const contextData: ProjectContextType = useMemo(
    () => ({
      selectedProject,
      setSelectedProject,
    }),
    [selectedProject, setSelectedProject],
  );

  return <ProjectContext.Provider value={contextData}>{children}</ProjectContext.Provider>;
});

export function useProject() {
  return useContext(ProjectContext);
}
